import React from 'react';
import CommonFieldWrapper from '../CommonFieldWrapper';
import AlertBadge from '../../../Icons/AlertBadge';

const Collapsed = (props) => {
    return <CommonFieldWrapper label={props.label}>
        <div className="w-full flex flex-row items-center justify-between cursor-pointer" onClick={props.expand}>
            <p className="m-2 text-sm text-muted fill-muted">
                {props.expandLabel ?? 'Tap to select'}
            </p>
            <p className="text-right">
                <AlertBadge icon="DownChevron" size="small" theme="info" />
            </p>
        </div>
    </CommonFieldWrapper>
}

export default Collapsed;